import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {FontSelection} from "../../models/theme";
import {ApiConfig} from "../api-config";
import {map, Observable, shareReplay} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FontService {

  key = '';

  _fonts: FontSelection[] = [];
  private allFonts$: Observable<FontSelection[]>;

  constructor(private http: HttpClient) {
    this.getAllFonts().subscribe(fonts => {
      this._fonts = fonts;
    });
  }

  public getAllFonts(): Observable<FontSelection[]> {
    if(this.allFonts$) return this.allFonts$;

    const url = 'https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyA7aleil1_LXt3oLJTEazl7MezKL7f7EMw';
    this.allFonts$ = this.http.get<{items: FontSelection[]}>(url).pipe(
      map(data => data.items),
      shareReplay(1)
    );
    return this.allFonts$;
  }

  searchAllFonts(q: string): Observable<FontSelection[]> {
    q = q.toLowerCase();
    return this.getAllFonts()
      .pipe(
        map(fonts =>
          fonts.filter(v => v.family.toLowerCase().startsWith(q)))
      );
  }
}
